/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-05-17 10:11:57
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbOrder {
    /**
     * 获取订单详情
     */
    export var GetOrderById = (body: any): Promise<any> => {
        return Get(`/api/TbOrder/GetOrderById`, body);
    };
  
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbOrder.ts